import * as vatReports from './list'

import type { InitialVatReport } from 'app/types/reports/vat'

export const allVatReports: InitialVatReport[] = Object.values(vatReports).sort(
    (previous, current) =>
        current.creation_date.localeCompare(previous.creation_date),
)
